<app-side-menu>
  <div class="group-create-container">
    <div class="card">
      <div class="card-header">
        <h3>
          <i class="fas fa-users me-2"></i>
          Criar Novo Grupo
        </h3>
      </div>

      <div class="card-body" [class.loading-overlay]="loading">
        <app-loading [show]="loading" message="Criando grupo..."></app-loading>
        
        <div *ngIf="!loading">
        <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">
          
          <!-- Informações Básicas -->
          <div class="form-section">
            <h5 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h5>

            <div class="row">
              <!-- Nome do Grupo -->
              <div class="col-12 mb-3">
                <label for="name" class="form-label required">Nome do Grupo</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  formControlName="name"
                  placeholder="Digite o nome do grupo"
                  [class.is-invalid]="hasError('name', 'required') || hasError('name', 'minlength') || hasError('name', 'maxlength')">
                <div class="invalid-feedback" *ngIf="groupForm.get('name')?.invalid && (groupForm.get('name')?.dirty || groupForm.get('name')?.touched)">
                  {{ getErrorMessage('name') }}
                </div>
                <small class="form-text text-muted">
                  Mínimo 3 caracteres, máximo 100 caracteres
                </small>
              </div>
            </div>

            <!-- Descrição -->
            <div class="row">
              <div class="col-12 mb-3">
                <label for="description" class="form-label">Descrição</label>
                <textarea
                  class="form-control"
                  id="description"
                  formControlName="description"
                  rows="3"
                  placeholder="Digite uma descrição para o grupo (opcional)"
                  [class.is-invalid]="hasError('description', 'maxlength')"></textarea>
                <div class="invalid-feedback" *ngIf="groupForm.get('description')?.invalid && (groupForm.get('description')?.dirty || groupForm.get('description')?.touched)">
                  {{ getErrorMessage('description') }}
                </div>
                <small class="form-text text-muted">
                  Máximo 500 caracteres
                </small>
              </div>
            </div>
          </div>

          <!-- Botões de Ação -->
          <div class="form-actions mt-4">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="onCancel()"
              [disabled]="loading">
              <i class="fas fa-times me-2"></i>
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="loading || groupForm.invalid">
              <i class="fas fa-save me-2"></i>
              Criar Grupo
            </button>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
